import { BREAKPOINTS } from '../../model/model';
import { isDefined, isNotDefined } from '../../utils/util';

class TopContent {
  constructor(options) {
    const _ = this;
    if (!options) return;
    _.option = $.extend({
      wrap: null,
      breakpoint: BREAKPOINTS,
      global: window,
      data : null
    }, options);
    _.global = (_.option.global) ? _.option.global : window;
  }

  init(obj) {
    const _ = this;
    // console.log( '# topContent.js init() _.option : ', _.option);
    if (isDefined(_.option.wrap) && _.option.wrap.length) _.setInstance();
    return _;
  }

  setInstance() {
    const _ = this;
    // console.log( '# topContent.js : _.option.data : ', _.option.data);
    let tmpl = _.option.data.items.map( (item, i) => {
      return `
        <section class="section-powerbook">
		<header><h2><a href="${item.headerUrl}">${item.header}</a></h2></header>
		<article>
			<a href="${item.url}">
				<dl><dd class="thumb" style="background-image:url('${item.thumbnail}');"><img src="${item.thumbnail}" class="thumb"></dd>
				<dt>${item.title}</dt>
				<dd class="desc">${item.desc}</dd>
				</dl>
			</a>
		</article>
	</section>
      `;
    }).join('');

    _.option.wrap.append(tmpl);

    _.addEvent();

  }
  addEvent() {
    const _ = this;
    _.option.wrap.slick({
      dots: true,
      infinite: false,
      arrows: false,
      speed: 300,
      slidesToScroll: 1,
      responsive: [
        {
          breakpoint: 4000,
          settings: "unslick"
        },
        {
          breakpoint: 640,
          slidesToShow: 1
        }
      ]
    });
    $(window).resize(function() {
      _.option.wrap.slick('resize');
    });
  }

}

export default TopContent;


// WEBPACK FOOTER //
// ./_src/js/main/content/TopContent.js